import React from 'react';
import ViewAllModal from './ViewAllModal';
import { useDispatch, useSelector } from 'react-redux';
import IconToolTip from '../../../common/IconToolTip';

import { closeModalAction, openCustomModal } from '../../../actions/modal';



export default function BoxUi({ name, data, onClick, showAddIcon, dataToShowPerRow, heading }) {

    const dispatch = useDispatch();

    const closeModal = () => {
        dispatch(closeModalAction())
    }


    const viewAllModal = (data, heading = 'view all', name) => {
        let modalComponent = <ViewAllModal data={data} closeModal={closeModal} />
        let modalWidth = '60em', modalHeight = '40em';
        let head = heading + ' | ' + name
        dispatch(openCustomModal({ modalComponent, heading: head, modalWidth, modalHeight }))
    }

    return <div className="flex flex-wrap gap-1 items-center">
        {Array.isArray(data) &&
            data?.slice(0, dataToShowPerRow)?.map((elem) => {
                return (
                    <IconToolTip title={elem} key={elem} >
                        <p className="bg-tagbg scogoprimary 2xl:text-font11 text-font10 px-p-6 py-p-3 rounded-3px mr-1 truncate">
                            {elem}
                        </p>
                    </IconToolTip>
                );
            })}
        {
            data?.length > dataToShowPerRow && <IconToolTip title="View all"><span
                className="text-font12 font-normal text-scogoorange cursor-pointer hover:text-scogobgsky"
                onClick={() => { viewAllModal(data, heading, name) }}
            >
                +{data?.length - dataToShowPerRow}
            </span></IconToolTip>
        }
        {showAddIcon ? <div className="flex items-center justify-between">
            <IconToolTip title="Add"><span
                className="material-icons cursor-pointer text-scogobgsky text-font12 hover:text-scogoorange"
                onClick={onClick}
            >
                edit
            </span></IconToolTip>
        </div> : <></>}
    </div>
}